/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";

export default function TeamMembersHead({ setFilter, filter }) {
  const { setSearchQuery } = useContext(filtrationcontext);
  const [query, setQuery] = useState("");
  
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };

  const systemRoleOptions = [
    { label: trans("All"), value: "" },
    { label: trans("Standard User"), value: "STANDARD_USER" },
    { label: trans("Supervisor"), value: "SUPERVISOR" },
    { label: trans("Project Manager"), value: "PROJECT_MANAGER" },
    { label: trans("System Administrator"), value: "SYSTEM_ADMINISTRATOR" },
  ];

  const accountStatusOptions = [
    // { label: trans("All"), value: "" },
    { label: trans("Active"), value: "active" },
    { label: trans("Deactivated"), value: "disabled" },
  ];

  const teamMembershipOptions = [
    { label: trans("All"), value: "" },
    { label: trans("Has team"), value: "has_team" },
    { label: trans("No team"), value: "no_team" },
  ];

  return (
    <>
      <div className="bg-white p-16 d-flex align-items-baseline gap-3">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />

        <InputSelect
          placeholder={trans("System Role")}
          options={systemRoleOptions}
          formstyle="flex-grow-1 text-capitalize"
          value={filter?.systemRole ?? undefined}
          onChange={(e) => {
            const systemRole = e !== null && e !== undefined && e !== "" ? e : null;
            setFilter((prev) => ({ ...prev, systemRole }));
          }}
        />

        <InputSelect
          placeholder={trans("Account Status")}
          options={accountStatusOptions}
          formstyle="flex-grow-1 text-capitalize"
          value={filter?.accountStatus ?? "active"}
          onChange={(e) => {
            const accountStatus = e !== null && e !== undefined && e !== "" ? e : "active";
            setFilter((prev) => ({ ...prev, accountStatus }));
          }}
        />

        <InputSelect
          placeholder={trans("Team Membership")}
          options={teamMembershipOptions}
          formstyle="flex-grow-1 text-capitalize"
          value={filter?.teamMembership ?? undefined}
          onChange={(e) => {
            const teamMembership = e !== null && e !== undefined && e !== "" ? e : null;
            setFilter((prev) => ({ ...prev, teamMembership }));
          }}
        />
      </div>
    </>
  );
}
